<template>
  <div id="app">
    <Splash v-if="!isStandAlone"/>
    <div class="header">
      <div class="logo"><img src="/assets/img/common/logo.png" alt=""></div>
      <!-- /.logo -->
      <div class="slideTabs">
        <div class="slideTab" data-tab="HOME"><button class="btn btn_slide active icon-">HOME</button></div>
        <div class="slideTab" data-tab="access"><button class="btn btn_slide icon-">アクセス</button></div>
        <div class="slideTab" data-tab="contact"><button class="btn btn_slide">お問い合わせ</button></div>
      </div>
      <!-- /.slideTabs -->
    </div>
    <!-- /.header -->
    <div class="container">
      <div class="panel current" data-tab="HOME">
        <SectionHeader />
        <HomeContents />
        <SectionFooter />
      </div>
      <div class="panel next" data-tab="access">
        <AccessContents />
        <SectionFooter />
      </div>
      <!-- <div class="panel" data-tab="about">
        <AboutContents />
        <SectionFooter />
      </div> -->
      <div class="panel" data-tab="contact">
        <ContactContents />
        <div class="wrapper wrapper_wide section_footer">
          <p class="copyright">© {{copyright}}</p>
        </div>
      </div>
    </div>
    <PcStickyBtns :isNegative="isNegative"/>
    <A2HS></A2HS>
  </div>
</template>

<script>
// atoms
import A2HS from './components/atoms/A2HS.vue'

// molcules
import Splash from './components/molcules/splash.vue'

// organisms
import SectionHeader from './components/organisms/sectionHeader.vue'
import SectionFooter from './components/organisms/sectionFooter.vue'
import PcStickyBtns from './components/organisms/pcStickyBtns.vue'

// templates
import HomeContents from './components/templates/homeContents.vue'
import AccessContents from './components/templates/accessContents.vue'
import AboutContents from './components/templates/aboutContents.vue'
import ContactContents from './components/templates/contactContents.vue'

import { mapState } from 'vuex'

export default {
  name: 'app',
  components: {
    A2HS,
    Splash,
    SectionHeader,
    SectionFooter,
    PcStickyBtns,
    HomeContents,
    AccessContents,
    AboutContents,
    ContactContents
  },
  data () {
    return {
      isNegative: false
    }
  },
  computed: {
    ...mapState([
      'isMobile',
      'siteData'
    ]),
    isStandAlone () {
      return navigator.standalone
    },
    copyright () {
      return this.siteData.info.copyright
    }
  },
  mounted () {
    // console.log(this.$el)
    //----------------------
    // 共通処理
    //----------------------
    // ブラウザ判定
    localStorage.setItem('broswerType', this.isMobile ? 'mobile' : 'pc');
    localStorage.setItem('broswerWidth', window.innerWidth);

    // リサイズ自動リロード
    window.addEventListener('resize', function(){
      const type = localStorage.getItem('broswerType');
      const ww = localStorage.getItem('broswerWidth');
      if (ww != window.innerWidth && type != (window.innerWidth < 415 ? 'mobile' : 'pc')) {
        location.href = location.href;
      }
    });

    if (this.isMobile) {
      //----------------------
      // SP用処理
      //----------------------
      window.addEventListener('load', function(){
        const currentPanel = document.querySelector('.current')
        const currentSecFooter = currentPanel.querySelector('.section_footer')
        const currentConsul = currentPanel.querySelector('.blk_consultation')
        // const consulMtop = Number(window.getComputedStyle(currentConsul)['marginTop'].slice(0, -2))
        const windowHeight = window.innerHeight
        // window.plimo.fusionPos = currentPanel.clientHeight - currentSecFooter.clientHeight - (currentConsul.clientHeight+consulMtop) - windowHeight + 58;
        window.plimo.sectionFooterPos = currentPanel.clientHeight - currentSecFooter.clientHeight - windowHeight
      })
      const $body = document.querySelector('body')
      if (navigator.standalone) {
        $body.classList.add('app')
      } else {
        $body.classList.add('web')
      }
      const ww = window.screen.width
      const wh = window.screen.height
      if (/iPhone/.test(navigator.userAgent)) {
        // iPhone
        let className = ''
        if (ww == 320) {
          $body.classList.add('iphone320')
        } else if (ww == 375) {
          if (wh == 667) {
            // 6,7,8
            $body.classList.add('iphone375')
          } else {
            // X
            $body.classList.add('iphoneX')
          }
        } else if (ww == 414) {
          $body.classList.add('iphonePlus')
        }
      } else if (/Android/.test(navigator.userAgent)) {
        // android
        if (wh < 600) {
          $body.classList.add('android600')
        } else if (wh < 650) {
          $body.classList.add('android650')
        } else if (wh < 700) {
          $body.classList.add('android700')
        } else if (wh < 750) {
          $body.classList.add('android750')
        } else {
          $body.classList.add('androidOver')
        }
      }
    } else {
      //----------------------
      // PC用処理
      //----------------------
      // 初期表示時メイン画像アニメーションの実行
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      const currentPanel = document.querySelector('.current')
      const currentSecHeader = currentPanel.querySelector('.section_header')
      const slideTabs = document.querySelector('.slideTabs')
      if (window.scrollY > windowHeight / 4 && windowWidth > 768) {
        currentSecHeader.classList.add('step_0', 'step_1');
      } else {
        currentSecHeader.classList.remove('step_0', 'step_1', 'step_2');
      }
      if (window.scrollY > windowHeight - slideTabs.offsetTop) {
        slideTabs.classList.add('negative');
        this.isNegative = true
      } else {
        slideTabs.classList.remove('negative');
        this.isNegative = false
      }
    }
  }
}
</script>

<style lang="scss">

</style>
